import axios from '../../apis/approvalsApi';
import { saveFile } from '../../utils/common';

export const FETCH_ZOOM_LOGGING_REQUEST = 'FETCH_ZOOM_LOGGING_REQUEST';
export const FETCH_ZOOM_LOGGING_SUCCESS = 'FETCH_ZOOM_LOGGING_SUCCESS';
export const FETCH_ZOOM_LOGGING_FAILURE = 'FETCH_ZOOM_LOGGING_FAILURE';

export const FETCH_ZOOM_CLEAN_LOGGING_REQUEST = 'FETCH_ZOOM_CLEAN_LOGGING_REQUEST';
export const FETCH_ZOOM_CLEAN_LOGGING_SUCCESS = 'FETCH_ZOOM_CLEAN_LOGGING_SUCCESS';
export const FETCH_ZOOM_CLEAN_LOGGING_FAILURE = 'FETCH_ZOOM_CLEAN_LOGGING_FAILURE';

export const EXPORT_ZOOM_LOGGING_REQUEST = 'EXPORT_ZOOM_LOGGING_REQUEST';
export const EXPORT_ZOOM_LOGGING_SUCCESS = 'EXPORT_ZOOM_LOGGING_SUCCESS';
export const EXPORT_ZOOM_LOGGING_FAILURE = 'EXPORT_ZOOM_LOGGING_FAILURE';

export const EXPORT_ZOOM_CLEAN_LOGGING_REQUEST = 'EXPORT_ZOOM_CLEAN_LOGGING_REQUEST';
export const EXPORT_ZOOM_CLEAN_LOGGING_SUCCESS = 'EXPORT_ZOOM_CLEAN_LOGGING_SUCCESS';
export const EXPORT_ZOOM_CLEAN_LOGGING_FAILURE = 'EXPORT_ZOOM_CLEAN_LOGGING_FAILURE';


export const fetchZoomLoggingRequest = () => ({
    type: FETCH_ZOOM_LOGGING_REQUEST,
});

export const fetchZoomLoggingSuccess = (data) => ({
    type: FETCH_ZOOM_LOGGING_SUCCESS, payload: data,
});

export const fetchZoomLoggingFailure = (error) => ({
    type: FETCH_ZOOM_LOGGING_FAILURE, payload: error,
});


export const exportZoomLoggingRequest = () => ({
    type: EXPORT_ZOOM_LOGGING_REQUEST,
});

export const exportZoomLoggingSuccess = (data) => ({
    type: EXPORT_ZOOM_LOGGING_SUCCESS, payload: data,
});

export const exportZoomLoggingFailure = (error) => ({
    type: EXPORT_ZOOM_LOGGING_FAILURE, payload: error,
});


export const fetchZoomCleanLoggingRequest = () => ({
    type: FETCH_ZOOM_CLEAN_LOGGING_REQUEST,
});

export const fetchZoomCleanLoggingSuccess = (data) => ({
    type: FETCH_ZOOM_CLEAN_LOGGING_SUCCESS, payload: data,
});

export const fetchZoomCleanLoggingFailure = (error) => ({
    type: FETCH_ZOOM_CLEAN_LOGGING_FAILURE, payload: error,
});


export const exportZoomCleanLoggingRequest = () => ({
    type: EXPORT_ZOOM_CLEAN_LOGGING_REQUEST,
});

export const exportZoomCleanLoggingSuccess = (data) => ({
    type: EXPORT_ZOOM_CLEAN_LOGGING_SUCCESS, payload: data,
});

export const exportZoomCleanLoggingFailure = (error) => ({
    type: EXPORT_ZOOM_CLEAN_LOGGING_FAILURE, payload: error,
});

export const fetchZoomLoggingData = ({ data, jwt }) => async (dispatch) => {
    try {
        dispatch(fetchZoomLoggingRequest());
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make GET request
        const response = await axios.post('/ZoomLicense/log', data, { headers: headers });
        console.log(response);
        dispatch(fetchZoomLoggingSuccess(response.data));
    } catch (ex) {
        console.error(ex);
        dispatch(fetchZoomLoggingFailure(ex.response?.data || ex.message));
    }
};

export const exportZoomLoggingData = ({ data, jwt }) => async (dispatch) => {
    try {
        dispatch(exportZoomLoggingRequest());
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make GET request
        const response = await axios.post('/ZoomLicense/export/log', data, { headers: headers, responseType: 'blob' });
        console.log(response);
        saveFile(response);
        dispatch(exportZoomLoggingSuccess(response.data));
    } catch (ex) {
        console.error(ex);
        dispatch(exportZoomLoggingFailure(ex.response?.data || ex.message));
    }
};

export const fetchZoomCleanLoggingData = ({ data, jwt }) => async (dispatch) => {
    try {
        dispatch(fetchZoomCleanLoggingRequest());

        console.log("Fetch Zoom Cleanup log API data: ", data);
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make GET request
        const response = await axios.post('/ZoomLicense/cleanup-log', data, { headers: headers });
        console.log("Get Cleanup log data API response: ", response.data);

        // let cleanUpDataTest = [
        //     {
        //         "message": "Successful run of zoom license clean up script",
        //         "id": "1",
        //         "eventType": "license.cleanup",
        //         "eventTimestamp": "2024-07-04T21:54:54",
        //         "assignedLicensesBefore": 5,
        //         "assignedLicensesAfter": 4,
        //         "availableLicensesBefore": 45,
        //         "availableLicensesAfter": 46,
        //         "users": "sample@intusurg.com"
        //     }
        // ]

        dispatch(fetchZoomCleanLoggingSuccess(response.data));
        //dispatch(fetchZoomCleanLoggingSuccess(cleanUpDataTest));
    } catch (ex) {
        console.error(ex);
        dispatch(fetchZoomCleanLoggingFailure(ex.response?.data || ex.message));
    }
};

export const exportZoomCleanLoggingData = ({ data, jwt }) => async (dispatch) => {
    try {
        dispatch(exportZoomCleanLoggingRequest());
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make GET request
        console.log("Export Data sent to Export API: ", data);
        const response = await axios.post('/ZoomLicense/export/cleanup-log', data, { headers: headers, responseType: 'blob' });
        console.log(response);
        saveFile(response);
        dispatch(exportZoomCleanLoggingSuccess(response.data));
    } catch (ex) {
        console.error(ex);
        dispatch(exportZoomCleanLoggingFailure(ex.response?.data || ex.message));
    }
};